import {
  getAvailableTranslations,
  getBooksForTranslation,
  getChaptersForBook,
  getChapterContent,
  searchBible as searchBibleApi,
  Translation,
  Book,
  Chapter
} from './bible-api';
import { supabase } from './supabase';

// Types
export interface BibleVerse {
  id: string;
  number: string;
  text: string;
}

export interface BibleChapter {
  id: string;
  number: string;
  reference: string;
  verses: BibleVerse[];
}

export interface BibleBookmark {
  id: string;
  user_id: string;
  book_id: string;
  chapter: number;
  verse?: number;
  note?: string;
  created_at: string;
}

export interface BibleNote {
  id: string;
  user_id: string;
  book_id: string;
  chapter: number;
  verse: number;
  text: string;
  created_at: string;
  updated_at: string;
}

// Lista completa de livros da Bíblia com informações corretas
export const books: { id: string; name: string; chapters: number; testament: 'old' | 'new' }[] = [
  { id: 'genesis', name: 'Gênesis', chapters: 50, testament: 'old' },
  { id: 'exodus', name: 'Êxodo', chapters: 40, testament: 'old' },
  { id: 'leviticus', name: 'Levítico', chapters: 27, testament: 'old' },
  { id: 'numbers', name: 'Números', chapters: 36, testament: 'old' },
  { id: 'deuteronomy', name: 'Deuteronômio', chapters: 34, testament: 'old' },
  { id: 'joshua', name: 'Josué', chapters: 24, testament: 'old' },
  { id: 'judges', name: 'Juízes', chapters: 21, testament: 'old' },
  { id: 'ruth', name: 'Rute', chapters: 4, testament: 'old' },
  { id: '1samuel', name: '1 Samuel', chapters: 31, testament: 'old' },
  { id: '2samuel', name: '2 Samuel', chapters: 24, testament: 'old' },
  { id: '1kings', name: '1 Reis', chapters: 22, testament: 'old' },
  { id: '2kings', name: '2 Reis', chapters: 25, testament: 'old' },
  { id: '1chronicles', name: '1 Crônicas', chapters: 29, testament: 'old' },
  { id: '2chronicles', name: '2 Crônicas', chapters: 36, testament: 'old' },
  { id: 'ezra', name: 'Esdras', chapters: 10, testament: 'old' },
  { id: 'nehemiah', name: 'Neemias', chapters: 13, testament: 'old' },
  { id: 'esther', name: 'Ester', chapters: 10, testament: 'old' },
  { id: 'job', name: 'Jó', chapters: 42, testament: 'old' },
  { id: 'psalms', name: 'Salmos', chapters: 150, testament: 'old' },
  { id: 'proverbs', name: 'Provérbios', chapters: 31, testament: 'old' },
  { id: 'ecclesiastes', name: 'Eclesiastes', chapters: 12, testament: 'old' },
  { id: 'songofsolomon', name: 'Cânticos', chapters: 8, testament: 'old' },
  { id: 'isaiah', name: 'Isaías', chapters: 66, testament: 'old' },
  { id: 'jeremiah', name: 'Jeremias', chapters: 52, testament: 'old' },
  { id: 'lamentations', name: 'Lamentações', chapters: 5, testament: 'old' },
  { id: 'ezekiel', name: 'Ezequiel', chapters: 48, testament: 'old' },
  { id: 'daniel', name: 'Daniel', chapters: 12, testament: 'old' },
  { id: 'hosea', name: 'Oséias', chapters: 14, testament: 'old' },
  { id: 'joel', name: 'Joel', chapters: 3, testament: 'old' },
  { id: 'amos', name: 'Amós', chapters: 9, testament: 'old' },
  { id: 'obadiah', name: 'Obadias', chapters: 1, testament: 'old' },
  { id: 'jonah', name: 'Jonas', chapters: 4, testament: 'old' },
  { id: 'micah', name: 'Miquéias', chapters: 7, testament: 'old' },
  { id: 'nahum', name: 'Naum', chapters: 3, testament: 'old' },
  { id: 'habakkuk', name: 'Habacuque', chapters: 3, testament: 'old' },
  { id: 'zephaniah', name: 'Sofonias', chapters: 3, testament: 'old' },
  { id: 'haggai', name: 'Ageu', chapters: 2, testament: 'old' },
  { id: 'zechariah', name: 'Zacarias', chapters: 14, testament: 'old' },
  { id: 'malachi', name: 'Malaquias', chapters: 4, testament: 'old' },
  { id: 'matthew', name: 'Mateus', chapters: 28, testament: 'new' },
  { id: 'mark', name: 'Marcos', chapters: 16, testament: 'new' },
  { id: 'luke', name: 'Lucas', chapters: 24, testament: 'new' },
  { id: 'john', name: 'João', chapters: 21, testament: 'new' },
  { id: 'acts', name: 'Atos', chapters: 28, testament: 'new' },
  { id: 'romans', name: 'Romanos', chapters: 16, testament: 'new' },
  { id: '1corinthians', name: '1 Coríntios', chapters: 16, testament: 'new' },
  { id: '2corinthians', name: '2 Coríntios', chapters: 13, testament: 'new' },
  { id: 'galatians', name: 'Gálatas', chapters: 6, testament: 'new' },
  { id: 'ephesians', name: 'Efésios', chapters: 6, testament: 'new' },
  { id: 'philippians', name: 'Filipenses', chapters: 4, testament: 'new' },
  { id: 'colossians', name: 'Colossenses', chapters: 4, testament: 'new' },
  { id: '1thessalonians', name: '1 Tessalonicenses', chapters: 5, testament: 'new' },
  { id: '2thessalonians', name: '2 Tessalonicenses', chapters: 3, testament: 'new' },
  { id: '1timothy', name: '1 Timóteo', chapters: 6, testament: 'new' },
  { id: '2timothy', name: '2 Timóteo', chapters: 4, testament: 'new' },
  { id: 'titus', name: 'Tito', chapters: 3, testament: 'new' },
  { id: 'philemon', name: 'Filemom', chapters: 1, testament: 'new' },
  { id: 'hebrews', name: 'Hebreus', chapters: 13, testament: 'new' },
  { id: 'james', name: 'Tiago', chapters: 5, testament: 'new' },
  { id: '1peter', name: '1 Pedro', chapters: 5, testament: 'new' },
  { id: '2peter', name: '2 Pedro', chapters: 3, testament: 'new' },
  { id: '1john', name: '1 João', chapters: 5, testament: 'new' },
  { id: '2john', name: '2 João', chapters: 1, testament: 'new' },
  { id: '3john', name: '3 João', chapters: 1, testament: 'new' },
  { id: 'jude', name: 'Judas', chapters: 1, testament: 'new' },
  { id: 'revelation', name: 'Apocalipse', chapters: 22, testament: 'new' }
];

// Lista de traduções disponíveis
export const translations: { id: string; name: string; language: string }[] = [
  { id: 'acf', name: 'Almeida Corrigida Fiel', language: 'pt' },
  { id: 'ara', name: 'Almeida Revista e Atualizada', language: 'pt' },
  { id: 'nvi', name: 'Nova Versão Internacional', language: 'pt' },
  { id: 'ntlh', name: 'Nova Tradução na Linguagem de Hoje', language: 'pt' }
];

// Cache for better performance
const translationsCache = new Map<string, Translation[]>();
const booksCache = new Map<string, Book[]>();
const chaptersCache = new Map<string, Chapter[]>();
const chapterContentCache = new Map<string, Chapter>();

// Get available translations
export async function getTranslations(): Promise<Translation[]> {
  if (translationsCache.has('translations')) {
    return translationsCache.get('translations')!;
  }

  try {
    const translations = await getAvailableTranslations();
    translationsCache.set('translations', translations);
    return translations;
  } catch (error) {
    console.error('Error fetching translations:', error);
    throw error;
  }
}

// Get books for a translation
export async function getBooks(translationId: string): Promise<Book[]> {
  if (booksCache.has(translationId)) {
    return booksCache.get(translationId)!;
  }

  try {
    const books = await getBooksForTranslation(translationId);
    booksCache.set(translationId, books);
    return books;
  } catch (error) {
    console.error('Error fetching books:', error);
    throw error;
  }
}

// Get chapters for a book
export async function getChapters(translationId: string, bookId: string): Promise<Chapter[]> {
  const cacheKey = `${translationId}_${bookId}`;
  
  if (chaptersCache.has(cacheKey)) {
    return chaptersCache.get(cacheKey)!;
  }

  try {
    const chapters = await getChaptersForBook(translationId, bookId);
    chaptersCache.set(cacheKey, chapters);
    return chapters;
  } catch (error) {
    console.error('Error fetching chapters:', error);
    throw error;
  }
}

// Get chapter content
export async function getChapter(translationId: string, chapterId: string): Promise<Chapter> {
  const cacheKey = `${translationId}_${chapterId}`;
  
  if (chapterContentCache.has(cacheKey)) {
    return chapterContentCache.get(cacheKey)!;
  }

  try {
    const chapter = await getChapterContent(translationId, chapterId);
    chapterContentCache.set(cacheKey, chapter);
    return chapter;
  } catch (error) {
    console.error('Error fetching chapter:', error);
    throw error;
  }
}

// Search the Bible
export async function searchBible(translationId: string, query: string): Promise<any> {
  try {
    return await searchBibleApi(translationId, query);
  } catch (error) {
    console.error('Error searching Bible:', error);
    throw error;
  }
}

// Functions for bookmarks and notes
export async function getBookmarks(): Promise<BibleBookmark[]> {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) return [];
    
    const { data, error } = await supabase
      .from('bible_bookmarks')
      .select('*')
      .eq('user_id', session.user.id)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error('Error fetching bookmarks:', error);
    return [];
  }
}

export async function addBookmark(bookmark: Omit<BibleBookmark, 'id' | 'created_at'>): Promise<BibleBookmark | null> {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) throw new Error('User not authenticated');

    const { data, error } = await supabase
      .from('bible_bookmarks')
      .insert([{
        ...bookmark,
        user_id: session.user.id
      }])
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error adding bookmark:', error);
    return null;
  }
}

export async function removeBookmark(id: string): Promise<boolean> {
  try {
    const { error } = await supabase
      .from('bible_bookmarks')
      .delete()
      .eq('id', id);

    if (error) throw error;
    return true;
  } catch (error) {
    console.error('Error removing bookmark:', error);
    return false;
  }
}

export async function getNotes(): Promise<BibleNote[]> {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) return [];
    
    const { data, error } = await supabase
      .from('bible_notes')
      .select('*')
      .eq('user_id', session.user.id)
      .order('updated_at', { ascending: false });

    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error('Error fetching notes:', error);
    return [];
  }
}

export async function addNote(note: Omit<BibleNote, 'id' | 'created_at' | 'updated_at'>): Promise<BibleNote | null> {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) throw new Error('User not authenticated');

    const { data, error } = await supabase
      .from('bible_notes')
      .insert([{
        ...note,
        user_id: session.user.id
      }])
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error adding note:', error);
    return null;
  }
}

// Clear cache functions
export function clearCache() {
  translationsCache.clear();
  booksCache.clear();
  chaptersCache.clear();
  chapterContentCache.clear();
}

export function clearTranslationCache(translationId: string) {
  booksCache.delete(translationId);
  for (const key of chaptersCache.keys()) {
    if (key.startsWith(translationId)) {
      chaptersCache.delete(key);
    }
  }
  for (const key of chapterContentCache.keys()) {
    if (key.startsWith(translationId)) {
      chapterContentCache.delete(key);
    }
  }
}